import { Fragment } from "react";
import TeamCard from "./teamCard";
import { useTranslation } from "react-i18next";

const MeetOutTeam = () => {
  const team = [
    {
      img: "/assets/team1.jpg",
      name: "ABDULLAH HASOUN",
      role: "Public Relations Manager",
      facebook: "/test",
      insta: "/test",
      twitter: "/test",
      youtube: "/test",
    },
    {
      img: "/assets/yahya.jpg",
      name: "YAHYA AHMAD ELİWİ",
      role: "CEO",
      facebook: "/test",
      insta: "/test",
      twitter: "/test",
      youtube: "/test",
    },
    {
      img: "/assets/bayan.jpg",
      name: "Bayan Alsgher",
      role: "Purchasing Manager",
      facebook: "/test",
      insta: "/test",
      twitter: "/test",
      youtube: "/test",
    },
    {
      img: "/assets/saad.jpg",
      name: "Saad Shams Alden",
      role: "Sales Manager",
      facebook: "/test",
      insta: "/test",
      twitter: "/test",
      youtube: "/test",
    },
  ];
  const { t } = useTranslation();
  return (
    <article className="py-10 bg-white">
      <div className="w-11/12 mx-auto">
        <h1 className="text-mainBlue text-[20px]  md:text-[32px] font-bold text-center">
          {t("meetOurTeam")}
        </h1>
      </div>
      <section className="grid my-4 md:grid-cols-2 lg:grid-cols-4">
        {team.map((t, i) => (
          <Fragment key={i}>
            <TeamCard member={t} />
          </Fragment>
        ))}
      </section>
    </article>
  );
};

export default MeetOutTeam;
